import { IPagination } from "./user";

export interface IInvoiceHistory {
  createdOn: string;
  name: string;
  remarks: string[];
  userId: string;
  userType: string;
}

export interface IInvoiceBrandInfo {
  _id: string;
  logoUrl: string;
  name: string;
  companyName: string;
  brandId: string;
}

export enum INVOICE_TYPE {
  Debit = "Debit",
  Credit = "Credit",
}
export enum INVOICE_SUB_TYPE {
  Invoice = "Invoice",
  CreditNote = "Credit-Note",
  Others = "Others",
}

export interface IBriefInvoice {
  _id: string;
  brand: IInvoiceBrandInfo;
  brandId: string;
  billing: {
    _id: string;
    name: string;
    billingId: string;
  };
  brief: {
    _id: string;
    brandName: string;
    name: string;
    briefId: string;
  };
  billingId: string;
  briefId: string;
  baseAmount: number;
  gstAmount: number;
  totalAmount: number;
  type: INVOICE_TYPE;
  subType: INVOICE_SUB_TYPE;
  url: string;
  invoiceNumber: string;
  createdBy: string;
  createdByModelName: string;
  createdByType: string;
  updatedBy: string;
  updatedByModelName: string;
  updatedByType: string;
  history: IInvoiceHistory[];
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export interface IGetBriefInvoices {
  data: IBriefInvoice[];
  pagination: IPagination;
}

export interface IGetBriefInvoiceFacets {
  billing: { name: string; _id: string }[];
  type: { _id: string }[];
  subType: { _id: string }[];
}

export interface ICreateBriefInvoice {
  briefId: string;
  baseAmount: number;
  gstAmount: number;
  type: INVOICE_TYPE;
  subType: INVOICE_SUB_TYPE;
  url?: string;
  invoiceNumber?: string;
}

export interface IEditBriefInvoice {
  brandInvoiceId: string;
  baseAmount: number;
  gstAmount: number;
  type: INVOICE_TYPE;
  subType: INVOICE_SUB_TYPE;
  url?: string;
  invoiceNumber?: string;
}

export interface IBriefInvoiceSearchRequest {
  briefId: string;
  pageNo?: number;
  limit?: number;
  searchQuery?: string;
  type?: INVOICE_TYPE[];
  subType?: INVOICE_SUB_TYPE[];
  billingId?: string[];
  isUrl?: string[];
  createdAtFrom: string;
  createdAtTo: string;
}

export interface IGetBriefInvoiceAggregation {
  debits: { baseAmount: number; gstAmount: number; totalAmount: number };
  credits: { baseAmount: number; gstAmount: number; totalAmount: number };
  all: { baseAmount: number; gstAmount: number; totalAmount: number };
}
